/**
 * @file
 * Initializes the carousel on the homepage.
 */
(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.homePageSwiperInit = {
    attach: function (context) {
      once('homepage-swiper-carousel', '.swiper', context).forEach(function(swiperDiv) {
        var swiper = new Swiper(".mySwiper", {
          slidesPerView: 'auto',
          spaceBetween: 15,
          loop: true,
          speed: 800,
          watchSlidesProgress: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
          // breakpoints: {
          //   0: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          //   },
          //   600: {
          //     slidesPerView: 1,
          //   },
          //   1200: {
          //     slidesPerView: 3,
          //     spaceBetween: 15,
          //   },
          // },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    }
  };

})(jQuery, Drupal, once);
